import { type ComponentProps, createElement } from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Text } from '@core/Components/Text'

type Props = {
  backgroundColor: string
  textColor: string
}

export const CompactPanelContainerStyled = styled.div<Props>(({ backgroundColor, textColor }) => ({
  backgroundColor,
  color: textColor,
  padding: '0 1.2rem',
}))

export const CompactPanelHeaderStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.9rem',
  padding: '0.3rem 0',
  color: hexColors.black,
})

const CompactPanelHeaderContentBase = styled(Text)({
  flex: '1 1 0%',
})

export const CompactPanelHeaderContentStyled = ({
  as = 'div',
  ...props
}: ComponentProps<typeof CompactPanelHeaderContentBase>) =>
  createElement(CompactPanelHeaderContentBase, { as, ...props })

const CompactPanelContentBase = styled(Text)({
  lineHeight: 1.1818,
  padding: '0.2rem 0 0.9rem',
})

export const CompactPanelContent = ({
  as = 'div',
  size = 'sm',
  ...props
}: ComponentProps<typeof CompactPanelContentBase>) =>
  createElement(CompactPanelContentBase, { as, size, ...props })
